module.exports = __webpack_public_path__ + "static/astro-13109120db7169e6943652b52dd5c51b.jpg";